"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledComment = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledComment = (0, styled_components_1.default)(material_1.Card) `
  &&.MuiPaper-root {
    flex-shrink: 0;
    border: none;
    box-shadow: none;
    color: ${({ theme }) => theme.palette.text.primary};

    &.comment--highlighted {
      background-color: ${ui_components_1.baseColors.primaryGreen001};
    }

    .MuiCardContent-root {
      display: flex;
      flex: 1;
      gap: ${({ theme }) => theme.spacing(1.5)};
      padding-bottom: ${({ theme }) => theme.spacing(2)};
    }

    .MuiCardHeader-root {
      padding: 0;
      gap: ${({ theme }) => theme.spacing(2)};

      .MuiCardHeader-content {
        overflow: hidden;

        .comment-title-user-name {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .MuiCardHeader-action {
      margin: 0;
    }
  }

  .comment-text-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;

    .comment-message {
      white-space: pre-wrap;
      word-break: break-word;
    }
  }
`;
